import React, { useEffect } from "react";
import "./BrownSuccessFullModal.css";
import { Button, Modal } from "react-bootstrap";
import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";
import Brown_Success_Lottie from "../../../Animation/Brown_Success_Lottie/Brown_Success_Lottie";
import { useNavigate } from "react-router-dom";

function BrownSuccessFullModal({ baseLink, ...props }) {

  const navigate = useNavigate()

  setTimeout(() => {

  
    props?.onHide();

    if(props?.navigateTo){
      navigate(props?.navigateTo)
    }    

  }, 5000);

  return (
    <>
      <section className="BrownSuccessFullModal modal-holder">
        <Modal
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="BrownSuccessFullModal modal-holder"
        >
          <Modal.Body>
            <div className="success_main_div">
              <div className="success_loottie_holder">
                <Brown_Success_Lottie />
              </div>

              <div className="success_content_holder">
                <div className="text_holder">
                  <p className="heading">{props?.successText}</p>

                  {props?.successText2 && (
                    <p className="heading">{props?.successText2}</p>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default BrownSuccessFullModal;
